<template>
  <div>
    <header-bar>
      {{ type === 'album' ? 'アルバム（2曲以上）': 'シングル' }}配信
    </header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">リリース情報登録 - 歌詞情報の登録</h3>
        <release-type-label :type="type" />
      </div>
      <div class="page-block__inner">
        <release-step-area :index="2">
          歌詞情報の登録
        </release-step-area>
      </div>
      <alert-view
        :errors="errors" />
      <div>
        <lyrics-store-logos />

        <ul class="c-indent-list">
          <li class="c-indent-list__node">
            歌唱通りの歌詞のみを入力し、歌詞以外の文字やタイトル、アーティスト名、著作者（作詞者・作曲者など）は入力しないでください。
          </li>
          <li class="c-indent-list__node">
            歌唱を繰り返す部分では（Repeat）等の表記は使わず、歌唱どおりに繰り返す部分も全て歌詞を記載して下さい。
          </li>
          <li class="c-indent-list__node">
            フェイクやコーラスなどの歌唱パートも記載して下さい。
          </li>
          <li class="c-indent-list__node">
            行同期歌詞入力の注意事項は
            <a
              :href="isBtoB ? 'https://cmap.zula.jp/client/faqs/119' : 'https://narasu.jp/client/faqs/118'"
              target="_blank"
              class="c-text-link">
              こちら
            </a>
          </li>
        </ul>
      </div>
      <form class="form--error">
        <div class="form-wrap wrap-form">
          <div class="first-step guidance">
            <strong class="title">その１: 歌詞情報を入力してください</strong>
            <ul>
              <li>
                下記の「歌詞情報を入力してください…」と記載されているエリアに歌詞を入力してください。
              </li>
            </ul>
          </div>
          <div
            v-show="!previewMode"
            class="form-group lyrics-group"
            style="">
            <div class="two-col dark-bg">
              <div class="time-bar">
                <span>LINE</span>
                <span>TIME</span>
              </div>

              <div class="right-section"></div>
            </div>

            <div
              ref="timeBar"
              class="two-col time-lyrics-scroll">
              <div
                ref="timeBarSection"
                class="lyrics-section">
                <div
                  v-for="(item, index) in originLyric"
                  :key="index"
                  :ref="activeIdx == index ? 'activeIdx' : ''"
                  :class="activeIdx == index ? 'active' : ''"
                  class="time-bar"
                  :currentidx="index"
                  @click.prevent="onClickActiveIdx">
                  <a
                    class="remove-line"
                    :targetidx="index"
                    @click.prevent="onClickRemoveLine">-</a>
                  <span class="line-no">{{ index + 1 }} </span>
                  <span
                    :ref="activeIdx == index ? 'currentTimeIdx' : ''"
                    class="set-time"
                    contentEditable="false"
                    :targetidx="index"
                    @click="enableEditTime"
                    @keypress="isValidTime"
                    @blur="updateEditedTime"
                    @keyup.enter="$event.target.blur()"
                    v-text="item[0] != null ? msToTime(Math.round(item[0] * 1000)) : '--:--.---'">
                  </span>
                </div>
              </div>

              <div class="lyrics-display">
                <textarea
                  id="lyrics"
                  ref="lyricsTextArea"
                  v-model="lyrics"
                  placeholder="歌詞情報を入力してください...."
                  class="form-control c-textarea c-lyrics-form"
                  @click.prevent="selectedClmn"
                  @keyup="selectedClmn"
                  @keydown="selectedClmn">
                </textarea>
                <p
                  v-if="errors.lyrics"
                  class="error-text">
                  {{ errors.lyrics[0] }}
                </p>
              </div>
            </div>
          </div>
          <div
            v-show="previewMode"
            class="border-wrap form-group lyrics-group"
            style="">
            <div class="two-col dark-bg">
              <div class="time-bar">
                <span>LINE</span>
                <span>TIME</span>
              </div>

              <div class="right-section"></div>
            </div>
            <div
              class="line_sync_preview_inner group-form invert">
              <div class="preview_row sticky first-row">
              </div>
              <div class="lyric">
                <LyricScroll
                  :lyric="originLyric"
                  :lyric-active-class="'lyric-active'"
                  :lyric-highlighted-class="'lyric-word'"
                  :lyric-center-class="'lyric-center'"
                  triangle-width="14px"
                  triangle-color="#fff"
                  center-line-color="#707070"
                  center-time-color="#707070"
                  :current-time="previewCurrentTime" />
              </div>
            </div>
          </div>

          <div class="last-step guidance">
            <strong class="title">その２:
              各行ごとの<span>歌い出し</span>に合わせて
              <span>SET</span>ボタンを押してください。
            </strong>
            <ul>
              <li>
                間違えた場合、行を戻ってセットし直してください。
              </li>
              <li>
                設定が完了したら、プレビュースイッチをONにして音源を再生し、間違いが無いか確認してください。
              </li>
            </ul>
            <ul>
              <li style="font-weight: bold; color: red">
                ※空行を設定する場合は前の行の歌い終わりの秒数をセットしてください。
              </li>
              <li style="font-weight: bold; color: red">
                ※歌詞の最後に1行空行を設定し、歌い終わりの秒数をセットしてください。
              </li>
            </ul>
          </div>
          <div class="music-ctrl">
            <a
              href="#"
              class="c-btn yellow-btn"
              :class="{ 'time-btn-off': !audioBtn }"
              @click.prevent="onStartClicked">
              SET
            </a>
            <audio-player
              :url="audioUrl"
              :current-play-url="currentPlayAudioUrl"
              :duration-string="duration"
              @timeupdate="timeupdate"
              @previewMode="onUpdatePreviewMode"
              @play-start="onPlayStart"
              @reset="onResetLyricsTime" />
          </div>
          <div class="save-btn">
            <a
              class="c-btn"
              href="#"
              @click.prevent="onSaveClicked(false)">
              歌詞を保存する
              <span class="c-btn__icon-arrow"></span>
            </a>
          </div>
          <div class="seperator"></div>
        </div>
      </form>
      <div class="sync-footer-btn">
        <a
          class="c-btn c-btn--back"
          href="#"
          @click.prevent="onReturnClicked">
          戻る
          <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../../HeaderBar'
import ReleaseTypeLabel from '../ReleaseTypeLabel'
import ReleaseStepArea from '../StepArea'
import AudioPlayer from '../../SyncAudioPlayer'
import AlertView from '../../AlertView'
import LyricScroll from '../../LyricsScroll'
import LyricsStoreLogos from './LyricsStoreLogos'

export default {
  name: 'ReleaseLyricsSyncForm',
  components: {
    AlertView,
    ReleaseStepArea,
    ReleaseTypeLabel,
    HeaderBar,
    AudioPlayer,
    LyricScroll,
    LyricsStoreLogos,
  },
  data() {
    return {
      errors: {},
      type: '',
      lyrics: '',
      audioUrl: '',
      duration: 0,
      currentPlayAudioUrl: '',
      currentTime: 0,
      previewCurrentTime: 0,
      startTime: 0,
      playing: '',
      audioBtn: false,
      audioPlayer: {},
      previewMode: false,
      toggle: false,
      originLyric: [],
      selectedIdx: 0,
    }
  },
  computed: {
    activeIdx() {
      // eslint-disable-next-line max-len
      if (this.originLyric.length !== 0 && this.selectedIdx === this.originLyric.length) return this.selectedIdx - 1
      return this.selectedIdx
    },
  },

  watch: {
    lyrics(newVal, oldVal) {
      this.errors = {}
      this.adjustHeight()

      const splitLines = (str) => (str ? str.replace(/\r/g, '').split('\n') : [])
      const newLines = splitLines(newVal)
      const oldLines = splitLines(oldVal)

      // 歌詞が空ならリセット
      if (newLines.length === 0) {
        this.originLyric = []
        this.currentTime = 0
        return
      }

      if (oldLines.length === 0) {
        if (this.originLyric.length === 0) {
          this.originLyric = newLines.map(text => [null, text])
        }
        return
      }

      let timeArray = this.originLyric.map(item => (item ? item[0] : null))

      if (timeArray.length < oldLines.length) {
        const diff = oldLines.length - timeArray.length
        timeArray = timeArray.concat(new Array(diff).fill(null))
      } else if (timeArray.length > oldLines.length) {
        timeArray = timeArray.slice(0, oldLines.length)
      }

      if (newLines.length !== oldLines.length) {
        let diffIndex = 0
        while (
          diffIndex < oldLines.length
          && diffIndex < newLines.length
          && newLines[diffIndex] === oldLines[diffIndex]
        ) {
          diffIndex += 1
        }

        if (newLines.length > oldLines.length) {
          const addedCount = newLines.length - oldLines.length
          const insertNulls = new Array(addedCount).fill(null)
          timeArray.splice(diffIndex, 0, ...insertNulls)
        } else {
          const removedCount = oldLines.length - newLines.length
          timeArray.splice(diffIndex, removedCount)
        }
      }

      this.originLyric = newLines.map((text, i) => {
        const time = (i < timeArray.length) ? timeArray[i] : null
        return [time, text]
      })

      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
  },
  mounted() {
    // セッションストレージから一時保存されたデータを読み込み
    const release = JSON.parse(window.sessionStorage.getItem('album'))
    if (!release) {
      this.$router.push({ name: 'index' })
      return
    }
    this.type = release.type
    this.fetchLyrics()
    this.updateAudio()
  },
  methods: {
    msToTime(duration) {
      const hour = Math.floor(duration / 3600000)
      const minute = Math.floor((duration - 3600000 * hour) / 60000)
      const mm = (`00${minute}`).slice(-2)
      const ms = (`00000${duration % 60000}`).slice(-5)
      const time = `${mm}:${ms.slice(0, 2)}.${ms.slice(2, 5)}`
      return time
    },
    // eslint-disable-next-line consistent-return
    isValidTime(event) {
      const char = String.fromCharCode(event.keyCode)
      if (/[0-9\-.:]+$/.test(char)) {
        return true
      }
      event.preventDefault()
    },
    enableEditTime(event) {
      const target = event.currentTarget
      target.contentEditable = true
      // プレースホルダーの場合は空にして入力をしやすくする
      if (target.innerText.trim() === '--:--.---') {
        target.innerText = ''
      }
      target.focus()
    },
    updateEditedTime(event) {
      const { target } = event
      target.contentEditable = false
      const currentIdx = Number(target.getAttribute('targetidx'))

      // contenteditable内にブラウザが勝手に入れた不要なタグや空白を除去
      const text = target.innerText.trim()
      const lyricText = this.originLyric[currentIdx][1]

      const formatAndSetDOM = (timeVal) => {
        target.innerText = timeVal != null ? this.msToTime(Math.round(timeVal * 1000)) : '--:--.---'
      }

      // 未入力やプレースホルダーに戻された場合はリセット
      if (!text || text === '--:--.---') {
        this.$set(this.originLyric, currentIdx, [null, lyricText])
        formatAndSetDOM(null) // 画面を強制リセット
        return
      }

      // フォーマットチェック
      if (!/^\d{2}:\d{2}\.\d{3}$/.test(text)) {
        this.$fire({
          type: 'warning',
          html: `時間のフォーマットが間違っています。 <br>
                再生時間をmm:ss.000形式にセットする必要があります。`,
          showConfirmButton: false,
          showCloseButton: true,
        })
        this.$set(this.originLyric, currentIdx, [null, lyricText])
        this.onSaveClicked(true)
        formatAndSetDOM(null) // 画面を強制リセット
        return
      }

      // 正常な時間が入力された場合の処理
      const setTime = text
      const startTime = setTime.split(':')
        .reduce((acc, time) => (Number(acc) * 60000 + (Number(time) * 1000))) / 1000
      const prevIdxSetTime = this.originLyric[currentIdx - 1]
        ? this.originLyric[currentIdx - 1][0] : 0
      let nextIdxSetTime = this.originLyric[currentIdx + 1]
        ? this.originLyric[currentIdx + 1][0] : startTime

      if (!nextIdxSetTime) {
        nextIdxSetTime = startTime
      }

      if (startTime > prevIdxSetTime && startTime <= nextIdxSetTime) {
        this.$set(this.originLyric, currentIdx, [startTime, lyricText])
        formatAndSetDOM(startTime)
        this.onSaveClicked(true)
      } else {
        this.$fire({
          type: 'warning',
          html: `後の行の時間よりも前の時間をセットする必要があります。<br>
                  後の行をリセットしたい場合は、後の行の時間をダブルクリックして <br>
                  修正するか、時間の左側にある「-」ボタンをクリックして時間を削除してください。`,
          showConfirmButton: false,
          showCloseButton: true,
        })
        this.$set(this.originLyric, currentIdx, [null, lyricText])
        formatAndSetDOM(null)
      }
    },
    onClickActiveIdx(event) {
      this.selectedIdx = event.currentTarget.getAttribute('currentidx')
    },
    onClickRemoveLine(event) {
      const targetIdx = Number(event.currentTarget.getAttribute('targetidx'))
      const lyricText = this.originLyric[targetIdx][1]

      this.$set(this.originLyric, targetIdx, [null, lyricText])

      this.$nextTick(() => {
        if (targetIdx !== 0) this.onSaveClicked(true)
      })
    },
    async fetchLyrics() {
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      const { discIndex, trackIndex } = this.$route.params
      const { data } = await window.axios.get(`/api/client/products/${release.product.id}/disc/${discIndex}/track/${trackIndex}/lyrics`)
      if (data.lyrics?.startsWith('{"lines"')) {
        let lyricObj = ''
        if (data && data.lyrics) {
          lyricObj = JSON.parse(data.lyrics)
        }
        let lyricText = ''
        const lyrData = []
        const lineLength = lyricObj.lines.length
        if (lineLength > 0 && lyricObj.lines[0].words[0].str.length > 0) {
          if (lyricObj.lines) {
            lyricObj.lines.forEach((line) => {
              lyricText += `${line.words[0].str || ''}\n`
            })

            lyricObj.lines.forEach((line, index) => {
              if (index < lineLength) {
                lyrData.push([
                  line.start / 1000,
                  line.words[0].str || '',
                ])
              }
            })
          }
        }
        this.lyrics = lyricText
        this.originLyric = lyrData

        if (lyrData.length > 0) {
          this.currentTime = lyrData.slice(-2)[0][2] ? lyrData.slice(-2)[0][2] : 0
        }
      } else {
        this.lyrics = data.lyrics || ''
      }
    },
    getPreviewData() {
      const data = []
      const currentLyric = this.lyrics.split('\n')
      // eslint-disable-next-line max-len
      if (this.originLyric.length !== 0 && currentLyric.length - 1 > this.originLyric.length) currentLyric.pop()

      currentLyric.forEach((lyric, index, array) => {
        // eslint-disable-next-line max-len
        if (this.originLyric.length !== 0 || index !== array.length - 1) data.push([this.originLyric[index] ? this.originLyric[index][0] : null, lyric])
      })
      return data
    },
    updateAudio() {
      const { discIndex, trackIndex } = this.$route.params
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      const { audio_file_url: audioUrl, duration } = release.discs[
        discIndex
      ].tracks[trackIndex]
      this.duration = duration.split(':').reduce((acc, time) => (60 * acc) + +time) * 1000
      this.audioUrl = audioUrl
    },
    onReturnClicked() {
      const { discIndex, trackIndex } = this.$route.params
      if (this.currentPlayAudioUrl && this.audioPlayer && typeof this.audioPlayer.pause === 'function') {
        this.audioPlayer.pause()
        this.audioPlayer.src = ''
      }
      this.$router.push({
        name: `${this.$route.meta.sideMenuId}-step2-lyrics`,
        hash: `#disc${discIndex}-track${trackIndex}`,
        params: {
          isBackMode: true,
        },
      })
    },
    onSaveReturnClicked() {
      const { discIndex, trackIndex } = this.$route.params
      if (this.currentPlayAudioUrl && this.audioPlayer && typeof this.audioPlayer.pause === 'function') {
        this.audioPlayer.pause()
        this.audioPlayer.src = ''
      }
      this.$router.push({
        name: `${this.$route.meta.sideMenuId}-step2`,
        hash: `#disc${discIndex}-track${trackIndex}`,
      })
    },
    onStartClicked() {
      const targetStartTime = (this.audioPlayer && typeof this.audioPlayer.currentTime === 'number')
        ? this.audioPlayer.currentTime
        : 0

      const currentIdx = Number(this.$refs.activeIdx[0].attributes.currentidx.value)

      if (currentIdx !== 0 && this.isInvalidLyrics()) this.onSaveClicked(true)
      else {
        const scrollTarget = this.$refs.timeBarSection.childNodes[0].scrollHeight
        const scrollFixLine = 8
        const prevIdxSetTime = this.originLyric[currentIdx - 1]
          ? this.originLyric[currentIdx - 1][0] : 0
        let nextIdxSetTime = this.originLyric[currentIdx + 1]
          ? this.originLyric[currentIdx + 1][0] : targetStartTime

        if (!nextIdxSetTime) {
          nextIdxSetTime = targetStartTime
        }

        if (targetStartTime > (prevIdxSetTime || 0) && targetStartTime <= nextIdxSetTime) {
          this.$nextTick(() => {
            const lyricText = this.originLyric[currentIdx][1]
            this.$set(this.originLyric, currentIdx, [targetStartTime, lyricText])
            this.onSaveClicked(true)
          })

          if (currentIdx >= scrollFixLine) {
            const scrollToEnd = scrollTarget * (currentIdx + 1 - scrollFixLine)
            setTimeout(() => { this.$refs.timeBar.scroll(0, scrollToEnd) }, 300)
          }

          if (currentIdx < this.lyrics.split(/\r?\n|\r/).length - 1) {
            this.selectedIdx = currentIdx + 1
          }
        } else {
          this.$fire({
            type: 'warning',
            html: `後の行の時間よりも前の時間をセットする必要があります。<br>
                  後の行をリセットしたい場合は、後の行の時間をダブルクリックして <br>
                  修正するか、時間の左側にある「-」ボタンをクリックして時間を削除してください。`,
            showConfirmButton: false,
            showCloseButton: true,
          })
          this.$nextTick(() => {
            const lyricText = this.originLyric[currentIdx][1]
            this.$set(this.originLyric, currentIdx, [null, lyricText])
          })
        }
      }
    },
    onSaveClicked(isRealTime) {
      if (this.isInvalidLyrics()) {
        this.$fire({
          type: 'warning',
          html: '1行目の時間と歌詞は必須です。',
          showConfirmButton: false,
          showCloseButton: true,
        })
      } else {
        try {
          const lines = []
          const release = JSON.parse(window.sessionStorage.getItem('album'))
          const { discIndex, trackIndex } = this.$route.params
          if (this.originLyric.length === 0) {
            const LyricsErrors = JSON.parse(window.sessionStorage.getItem('hasLyricsError') || '{}')
            LyricsErrors[`${discIndex}-${trackIndex}`] = false
            window.sessionStorage.setItem('hasLyricsError', JSON.stringify(LyricsErrors))
            const LyricsCompletePercentages = JSON.parse(window.sessionStorage.getItem('lyricsCompletePercentage') || '{}')
            LyricsCompletePercentages[`${discIndex}-${trackIndex}`] = 0
            window.sessionStorage.setItem('lyricsCompletePercentage', JSON.stringify(LyricsCompletePercentages))
          } else {
            if (!isRealTime && this.currentPlayAudioUrl) {
              this.audioPlayer.pause()
            }
            const lastLyric = this.originLyric[this.originLyric.length - 1]

            if (!isRealTime && (lastLyric[0] == null || lastLyric[0] === 0) && lastLyric[1] === '') {
              this.originLyric.pop()
            }

            this.originLyric.forEach((line) => {
              lines.push({
                start: line[0] ? parseInt(Math.round(line[0] * 1000), 10) : null,
                words: [
                  {
                    start: line[0] ? parseInt(Math.round(line[0] * 1000), 10) : null,
                    str: line[1],
                  },
                ],
              })
            })

            let blankTimeCount = 0
            let lyricsCount = lines.length
            // eslint-disable-next-line array-callback-return
            lines.map((line) => {
              if (line.start == null) blankTimeCount += 1
            })

            if (lyricsCount > 0 && lines[lyricsCount - 1].words[0].str != null && lines[lyricsCount - 1].words[0].str !== '') {
              lyricsCount += 1
              blankTimeCount += 1
            }

            const lyricsCompletePercentage = Math.floor((1 - blankTimeCount / lyricsCount) * 100)
            const LyricsErrors = JSON.parse(window.sessionStorage.getItem('hasLyricsError') || '{}')

            if (lyricsCompletePercentage === 100) {
              LyricsErrors[`${discIndex}-${trackIndex}`] = false
            } else {
              LyricsErrors[`${discIndex}-${trackIndex}`] = true
            }
            window.sessionStorage.setItem('hasLyricsError', JSON.stringify(LyricsErrors))
            const LyricsCompletePercentages = JSON.parse(window.sessionStorage.getItem('lyricsCompletePercentage') || '{}')
            LyricsCompletePercentages[`${discIndex}-${trackIndex}`] = lyricsCompletePercentage
            window.sessionStorage.setItem('lyricsCompletePercentage', JSON.stringify(LyricsCompletePercentages))
          }
          const metaData = {}
          this.$set(metaData, 'lineNum', lines.length)
          this.$set(metaData, 'wordNum', this.lyrics.trim().replace(/\s+/gi, ' ').split(' ').length)
          this.$set(metaData, 'time', this.duration)
          const saveData = {}
          if (lines.length === 0) {
            // 歌詞が何も入力されてなければ仮の空データを差し込む
            lines.push(
              {
                start: 0,
                words: [
                  {
                    start: 0,
                    str: null,
                  },
                ],
              },
            )
          }

          this.$set(saveData, 'lines', lines)
          this.$set(saveData, 'meta', metaData)
          const headers = { 'X-CMAP-No-Loading': true }
          window.axios.post(
            `/api/client/products/${release.product.id}/disc/${discIndex}/track/${trackIndex}/lyrics`,
            {
              lyrics: JSON.stringify(saveData),
              lyrics_type: 2,
            },
            {
              headers,
            },
          )

          release.discs[discIndex].tracks[trackIndex].lyrics_type = 2
          release.discs[discIndex].tracks[trackIndex].syncLyrics = saveData
          window.sessionStorage.setItem('album', JSON.stringify(release))

          if (!isRealTime) {
            this.onSaveReturnClicked()
          }
        } catch ({ response }) {
          const { errors } = response.data
          this.errors = errors
          window.scrollTo(0, 0)
        }
      }
    },
    isInvalidLyrics() {
      if (this.originLyric.length !== 0) {
        const firstTime = this.originLyric[0][0]
        const firstText = this.originLyric[0][1]

        if (firstTime === null || !firstText || firstText.trim() === '') {
          return true
        }
      }
      return false
    },
    onPlayStart(url, audioPlayer, currentTime) {
      this.currentTime = currentTime
      this.currentPlayAudioUrl = url
      this.audioPlayer = audioPlayer
      this.audioPlayer.addEventListener('play', () => {
        if (!this.previewMode) {
          this.audioBtn = true
        } else {
          // Preview mode
          this.audioBtn = false
        }
      })

      this.audioPlayer.addEventListener('pause', () => {
        this.audioBtn = false
      })

      if (!this.previewMode) {
        this.audioBtn = true
      }
    },
    onResetLyricsTime() {
      this.$fire({
        title: 'リセット',
        html: '行同期歌詞をすべてリセットします。<br> よろしいですか？',
        // type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        // showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.originLyric = []
          this.selectedIdx = 0
          this.$nextTick(() => {
            this.originLyric = this.getPreviewData()
          })
          this.currentTime = 0
          if (this.currentPlayAudioUrl && this.audioPlayer && typeof this.audioPlayer.currentTime === 'number') {
            this.audioPlayer.currentTime = 0
            this.audioPlayer.pause()
          }
          this.$refs.timeBar.scroll(0, 0)
        }
      })
    },
    timeupdate(newTime) {
      this.previewCurrentTime = newTime
    },
    onUpdatePreviewMode(data) {
      this.previewCurrentTime = 0
      this.previewMode = data
      this.audioBtn = false
      if (this.currentPlayAudioUrl && this.audioPlayer && typeof this.audioPlayer.currentTime === 'number') {
        this.audioPlayer.pause()
        this.audioPlayer.currentTime = 0
      }
    },
    selectedClmn(event) {
      if (!event.isComposing) {
        this.adjustHeight()
        const lineNo = this.lyrics.substr(0, this.$refs.lyricsTextArea.selectionStart).split('\n').length - 1
        this.selectedIdx = lineNo
      }
    },
    adjustHeight() {
      const textarea = this.$refs.lyricsTextArea
      const resetHeight = new Promise(((resolve) => {
        resolve(textarea.style.height = 'auto')
      }))
      resetHeight.then(() => {
        textarea.style.height = `${textarea.scrollHeight}px`
      })
    },
    closeModel() {
      this.showWarning = false
    },
  },
}

</script>

<style scoped>
@media screen and (min-width: 896px) {
  .c-btn-wrap {
    margin: 0 20px 0 20px;
  }
  .c-indent-list {
    padding: 10px 40px 10px;
  }
}
@media screen and (max-width: 896px) {
  .c-indent-list {
    padding: 10px 20px 10px;
  }
}
</style>
